module.exports = __webpack_public_path__ + "img/limitManage.2d12cce6.svg";